import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label", "aria-hidden"]
const _hoisted_2 = { class: "au-drawer-head" }
const _hoisted_3 = { class: "d-flex align-items-start gap-3" }
const _hoisted_4 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_5 = { class: "au-drawer-name" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "au-chip" }
const _hoisted_8 = { class: "au-drawer-desc" }
const _hoisted_9 = ["title", "aria-label"]
const _hoisted_10 = ["title", "aria-label"]
const _hoisted_11 = { class: "au-drawer-body" }
const _hoisted_12 = { class: "au-drawer-section" }
const _hoisted_13 = {
  key: 0,
  class: "au-empty"
}
const _hoisted_14 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_15 = { class: "visually-hidden" }
const _hoisted_16 = {
  key: 1,
  class: "au-drawer-empty"
}
const _hoisted_17 = { class: "d-flex align-items-center gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_19 = { class: "ms-auto fw-semibold" }
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = { class: "au-lic-key" }
const _hoisted_22 = ["title", "aria-label", "onClick"]
const _hoisted_23 = { class: "d-flex align-items-center mt-2 gap-2" }
const _hoisted_24 = { class: "au-lic-meta" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["aria-expanded"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "d-flex align-items-center gap-2" }
const _hoisted_29 = { class: "badge bg-secondary" }
const _hoisted_30 = { class: "ms-auto fw-semibold" }
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = { class: "au-lic-key" }
const _hoisted_33 = { class: "au-lic-meta mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_action_menu = _resolveComponent("bs5-action-menu")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["au-drawer-overlay", { 'is-open': _ctx.visible }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, null, 2),
    _createElementVNode("aside", {
      class: _normalizeClass(["au-drawer", { 'is-open': _ctx.visible }]),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": _ctx.client?.name ?? '',
      "aria-hidden": !_ctx.visible
    }, [
      (_ctx.client)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "au-avatar" }, [
                  _createElementVNode("i", { class: "bi bi-buildings" })
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.client.name), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-shop" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.client.distributorName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.client.description || _ctx.$t("clients.noDescription")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "au-drawer-icon",
                  title: _ctx.$t('clients.editClient'),
                  "aria-label": _ctx.$t('clients.editClient'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit', _ctx.client.id)))
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                ]), 8, _hoisted_9),
                _createElementVNode("button", {
                  type: "button",
                  class: "au-drawer-icon",
                  title: _ctx.$t('clients.closePanel'),
                  "aria-label": _ctx.$t('clients.closePanel'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                ]), 8, _hoisted_10)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h3", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-patch-check-fill text-success" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t("licenses.panel.title")), 1)
                ]),
                _createVNode(_component_bs5_base_button, {
                  variant: "primary",
                  size: "sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('issue', _ctx.client.id)))
                }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-file-earmark-plus" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t("clients.generateLicense")), 1)
                  ]),
                  _: 1
                })
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("common.loading")), 1)
                    ])
                  ]))
                : (_ctx.activeLicenses.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-patch-question fs-3 d-block mb-2" }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("licenses.panel.empty")), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("licenses.panel.emptyHint")), 1)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.activeLicenses, (license) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: license.id,
                        class: _normalizeClass(["au-lic-card", { 'is-new': _ctx.newLicenseIds.includes(license.id as string) }])
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.badgeClass(license)])
                          }, _toDisplayString(_ctx.stateLabel(license)), 3),
                          (_ctx.newLicenseIds.includes(license.id as string))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("licenses.panel.new")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.validity(license)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-cpu" }, null, -1)),
                            _createTextVNode(_toDisplayString(license.licenseKey) + " ", 1),
                            _createElementVNode("button", {
                              type: "button",
                              title: _ctx.$t('licenses.panel.copyKey'),
                              "aria-label": _ctx.$t('licenses.panel.copyKey'),
                              onClick: ($event: any) => (_ctx.copyKey(license.licenseKey))
                            }, _cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "bi bi-copy" }, null, -1)
                            ]), 8, _hoisted_22)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("span", _hoisted_24, [
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-calendar-check me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("licenses.panel.issuedOn", { date: _ctx.formatDate(license.issuedDate) })), 1)
                          ]),
                          _createVNode(_component_bs5_base_button, {
                            variant: "primary",
                            size: "sm",
                            class: "ms-auto",
                            onClick: ($event: any) => (_ctx.downloadLicense(license))
                          }, {
                            default: _withCtx(() => [
                              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-download" }, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.$t("licenses.download")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_bs5_action_menu, {
                            label: _ctx.$t('licenses.panel.more')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "au-menu-item is-danger",
                                role: "menuitem",
                                onClick: ($event: any) => (_ctx.deleteLicense(license))
                              }, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-slash-circle" }, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t("licenses.panel.removeFromPanel")), 1)
                              ], 8, _hoisted_25)
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ])
                      ], 2))
                    }), 128)),
              (!_ctx.loading && _ctx.inactiveLicenses.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "au-link-btn",
                      "aria-expanded": _ctx.showInactive,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showInactive = !_ctx.showInactive))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['bi', _ctx.showInactive ? 'bi-chevron-up' : 'bi-chevron-down', 'me-1'])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.showInactive ? "licenses.panel.hideInactive" : "licenses.panel.showInactive",
                                { count: _ctx.inactiveLicenses.length })), 1)
                    ], 8, _hoisted_26),
                    (_ctx.showInactive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveLicenses, (license) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: license.id,
                              class: "au-lic-card is-off"
                            }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("licenses.inactive")), 1),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.validity(license)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, [
                                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-cpu" }, null, -1)),
                                  _createTextVNode(_toDisplayString(license.licenseKey), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-calendar-check me-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("licenses.panel.issuedOn", { date: _ctx.formatDate(license.issuedDate) })), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ]))
}